import { Box, Popper as MUIPopper, styled } from '@mui/material';
import { fontWeight } from '@app/theme/typography';
import { HFlex, VFlex } from '@app/components/FlexContainers';
import { palette } from '@app/theme/palette';
import { RightTriangleIcon } from '@app/components/icons/RightTriangleIcon';

export const Root = styled(Box)`
  position: relative;
  width: 41px;
  height: 28px;
  cursor: pointer;
  z-index: 1;
`;

export const Popper = styled(MUIPopper)`
  filter: drop-shadow(0px 8px 15px rgba(0, 0, 0, 0.1)) drop-shadow(0px -1px 15px rgba(0, 0, 0, 0.1));
`;

export const ContentWrapper = styled(HFlex)`
  align-items: center;
`;

export const Content = styled(VFlex)`
  min-width: 183px;
  padding: 15px;
  background: ${palette.primary.contrastText};
  border-radius: 5px;
`;

export const ListItem = styled(Box)`
  color: #727276;
  font-size: 14px;
  font-style: normal;
  font-weight: ${fontWeight.regular};
  line-height: 32px;
  letter-spacing: 0.35px;

  cursor: pointer;
  transition: padding 0.5s;
  padding-right: 20px;

  &:hover {
    background: ${palette.custom.lightGrey};
    border-radius: 5px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

export const ArrowContainer = styled(Box)`
  display: contents;
`;

export const Arrow = styled(RightTriangleIcon)`
  margin-right: 5px;
  height: 36px;
  width: 15px;
`;
